export const FREQUENCY_OPTIONS = [
  {
    value: "immediately",
    label: "Immediately"
  },
  {
    value: "daily",
    label: "Daily"
  },
  {
    value: "biweekly",
    label: "Biweekly"
  },
  {
    value: "monthly",
    label: "Monthly"
  }
];

export const FORM_DEFAULT_VALUES = {
  maximumValue: null,
  minimumValue: null,
  minimumDiscount: 1,
  frequency: null
};
